export const CAIP_PATTERNS = {
  /** Namespace pattern: [-a-z0-9]{3,8} */
  NAMESPACE: /^[-a-z0-9]{3,8}$/,

  /** Chain reference pattern: [-_a-zA-Z0-9]{1,32} */
  CHAIN_REFERENCE: /^[-_a-zA-Z0-9]{1,32}$/,

  /** Asset namespace pattern: [-a-z0-9]{3,8} */
  ASSET_NAMESPACE: /^[-a-z0-9]{3,8}$/,

  /** Account address and asset reference pattern: [-.%a-zA-Z0-9]{1,128} */
  REFERENCE: /^[-.%a-zA-Z0-9]{1,128}$/,

  /** Raw Sui Move type tag, including case-sensitive generic type arguments. */
  MOVE_TYPE_TAG:
    /^(?=.{1,512}$)0x[0-9a-fA-F]+::[a-zA-Z0-9_]+::[a-zA-Z0-9_]+(?:<[a-zA-Z0-9_:<>,]+>)?$/,

  /** Chain ID pattern: {namespace}:{reference} */
  CHAIN_ID: /^[-a-z0-9]{3,8}:[-_a-zA-Z0-9]{1,32}$/,

  /** Account ID pattern: {chain_id}:{account_address} */
  ACCOUNT_ID: /^[-a-z0-9]{3,8}:[-_a-zA-Z0-9]{1,32}:[-.%a-zA-Z0-9]{1,128}$/,

  /** Asset ID pattern: {chain_id}/{asset_namespace}:{asset_reference} */
  ASSET_ID:
    /^[-a-z0-9]{3,8}:[-_a-zA-Z0-9]{1,32}\/[-a-z0-9]{3,8}:[-.%a-zA-Z0-9]{1,128}$/,
} as const;
